// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"455627db","59":"958b1322","162":"a05419be","314":"79b4f29b","393":"a3465ad1","466":"a13802f8","862":"ad84ebbb"}[chunkId] + ".chunk.js";
};